import { useState, useEffect } from 'react';
import axios from 'axios';
import { API_LONG_REQUEST_TIMEOUT_MS } from '../constants/AppConstants';

export default function useAuthenticatedImageUrl(url) {
  const [blobUrl, setBlobUrl] = useState(null);

  useEffect(() => {
    if (!url) return undefined;
    let objectUrl;
    let cancelled = false;

    axios.get(url, { responseType: 'blob', timeout: API_LONG_REQUEST_TIMEOUT_MS })
      .then(({ data }) => {
        if (!cancelled) {
          objectUrl = URL.createObjectURL(data);
          setBlobUrl(objectUrl);
        }
      })
      .catch(() => {
        if (!cancelled) setBlobUrl(null);
      });

    return () => {
      cancelled = true;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [url]);

  return blobUrl;
}
